import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedicalStaffingSolutionsBanner } from "../images";
import { ContactUsButton } from "../components/ContactUsButton/ContactUsButton";

export const RemoteSiteMedicalSolutions = () => {
    const { t } = useTranslation();
    const keyFeatures = t('remoteSiteMedicalSolutions.pageList', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={MedicalStaffingSolutionsBanner} title={t('remoteSiteMedicalSolutions.bannerTitle')} />

            <ContentPanel headerText={t('remoteSiteMedicalSolutions.header')}>
                <h4 className="text-xl mb-5">{t('generic.keyFeatures')}</h4>

                <p className="mb-5">{t('remoteSiteMedicalSolutions.paragraph1')}</p>
                
                <h4 className="text-xl mb-5">{t('remoteSiteMedicalSolutions.subHeader')}</h4>

                <p className="mb-5">{t('remoteSiteMedicalSolutions.paragraph2')}</p>

                <h4 className="text-xl mb-5">{t('remoteSiteMedicalSolutions.ourCoreCapabilities')}</h4>

                <UnorderedList items={keyFeatures} hasCheckmark={false} />

                <h4 className="text-xl my-5">{t('generic.industriesServed')}</h4>
                <span className="text-white leading-relaxed">{t('remoteSiteMedicalSolutions.industriesServed')}</span>

                <ContactUsButton title={t('remoteSiteMedicalSolutions.contactUsTitle')} />
            </ContentPanel>
        </div>
    );
};